import React from 'react';
import core from '@gin-betting/core';

import moduleLocator from 'moduleLocator';
import CategorizerControlsStub from './components/Categorizer/CategorizerControls/CategorizerControlsStub';
import CategorizerStub from './components/Categorizer/CategorizerStub';

const {
    utils: { measureTime },
    hocs: { withAsyncLoad },
} = core;

export const loadFiltersModule = () =>
    import(/* webpackChunkName: "filters-module" */ './index').then(
        filtersModule => {
            measureTime('filtersModuleLoaded');
            moduleLocator.set('filters', filtersModule);

            return filtersModule;
        }
    );

/* eslint-disable react/display-name */
export const AsyncCategorizer = withAsyncLoad({
    loader: loadFiltersModule,
    delayLoading: 1000,
    loading: () => <CategorizerStub />,
    componentToRender: 'Categorizer',
});

export const AsyncFilters = withAsyncLoad({
    loader: loadFiltersModule,
    loading: () => null,
    componentToRender: 'Filters',
});

// TODO:  AsyncControls, Controls should be removed if it outdated component.
// export const AsyncControls = withAsyncLoad({
//     loader: loadFiltersModule,
//     loading: () => null,
//     componentToRender: 'Controls',
// });

export const AsyncMobileFilters = withAsyncLoad({
    loader: loadFiltersModule,
    loading: () => null,
    componentToRender: 'MobileFilters',
});

export const AsyncCategorizerControls = withAsyncLoad({
    loader: loadFiltersModule,
    loading: () => <CategorizerControlsStub />,
    componentToRender: 'CategorizerControls',
});

export const AsyncCategorizerTabletContainer = withAsyncLoad({
    loader: loadFiltersModule,
    loading: () => null,
    componentToRender: 'CategorizerTabletContainer',
});

export const AsyncCategorizerLive = withAsyncLoad({
    loader: loadFiltersModule,
    loading: () => null,
    componentToRender: 'CategorizerLive',
});

export const AsyncCategorizerNextToGo = withAsyncLoad({
    loader: loadFiltersModule,
    loading: () => null,
    componentToRender: 'CategorizerNextToGo',
});
